'use client';

import React from 'react';
import { Avatar, Fab, Tooltip } from '@mui/material';
import { useRouterPush, useTranslator } from '@ianesthesie-kit/core';
import { LastOpenedPatient } from '@/modules/ui';
import { getInitials } from '@/util';

type LastOpenedPatientFabProps = {
  patient: LastOpenedPatient;
};

/** One-click way back to the dossier the user opened last. Shows the patient's initials, full name on hover. */
export const LastOpenedPatientFab = ({
  patient
}: LastOpenedPatientFabProps) => {
  const push = useRouterPush();
  const translate = useTranslator();
  const label = translate(
    'doctor-dashboard.lastOpenedPatient.backTo',
    undefined,
    {
      name: patient.name
    }
  );

  return (
    <Tooltip title={label} placement="left">
      <Fab
        size="small"
        aria-label={label}
        onClick={() => push(`/patients/${patient.id}`)}
        sx={{
          bgcolor: 'background.paper',
          border: 2,
          borderColor: 'primary.main',
          '&:hover': { bgcolor: 'primary.xLight' }
        }}
      >
        <Avatar
          data-sentry-mask
          sx={{
            width: 36,
            height: 36,
            bgcolor: 'transparent',
            color: 'primary.dark',
            fontSize: 13,
            fontWeight: 700,
            letterSpacing: 0.5
          }}
        >
          {getInitials(patient, true)}
        </Avatar>
      </Fab>
    </Tooltip>
  );
};
